module.exports = __webpack_public_path__ + "static/media/nextWhite.2415a2a5.svg";